/**
 * Fee events — chunk 2, item 9 (FeeChip, and the deal profile's fees tab).
 *
 * Contract mirror: labourcore-api/src/modules/fees/.
 *
 * The three lifecycle mutators ran
 *   `supabase.from("fee_events").update(patch).eq("id", id)`
 * from the browser — scoped by row id alone, on a table with RLS disabled and
 * reachable through __table_proxy by any authenticated user. Anyone who learned
 * a fee event id could mark another company's introduction fee paid or waived.
 * Same shape as Live-Defects-Log #27.
 *
 * WHICH side may move a fee is a separate, undecided question — PD-4. Both
 * sides can today, and that is preserved.
 */

import { apiGet, apiPost } from "./client";

export type Row = Record<string, unknown>;

/** The placement's fee event, or null. Scoped to the caller's companies. */
export function fetchPlacementFeeEvent(placementId: string): Promise<Row | null> {
  return apiGet<Row | null>(`/api/placements/${placementId}/fee-event`);
}

/** One route per named transition, so the status is not a field in a body. */
export function markFeeInvoiced(feeEventId: string, notes?: string | null): Promise<Row> {
  return apiPost<Row>(`/api/fee-events/${feeEventId}/invoice`, { notes: notes ?? null });
}

export function markFeePaid(feeEventId: string, notes?: string | null): Promise<Row> {
  return apiPost<Row>(`/api/fee-events/${feeEventId}/paid`, { notes: notes ?? null });
}

export function markFeeWaived(feeEventId: string, notes?: string | null): Promise<Row> {
  return apiPost<Row>(`/api/fee-events/${feeEventId}/waived`, { notes: notes ?? null });
}
